export interface NotificationSettings {
  sms?: boolean;
  email?: boolean;
  [key: string]: any; 
}

export interface Preferences {
  personalActivity: Record<string, NotificationSettings>;
  organizationActivity: Record<string, NotificationSettings>;
}

export interface NotificationsState {
  currentPreferences: Preferences;
  orgType: string;
  role: string;
  phone: string;
  isSmsAllowed: boolean;
}

export interface NotificationSectionsType {
    title: string;
    type: 'personalActivity' | 'organizationActivity';
    notifications: any[]
  }

export const initialState: NotificationsState = {
  currentPreferences: {
    personalActivity: {},
    organizationActivity: {}
  },
  orgType: '',
  role: '',
  phone: '',
  isSmsAllowed: false
};